/* ============================================================
   OSMANLI DOĞAL TAŞ — Enneagram 3B sembolü (Canvas 2D, WebGL yok)

   GEOMETRİ
   · 9 nokta çember üzerinde 40° aralıkla; 9 tepede (-90°), saat yönünde 1..8
   · Üçgen : 3-6-9
   · Heksad: 1-4-2-8-5-7-1  (1/7 = 0,142857… periyodunun rakam sırası)
   · Stres oku kırmızı, büyüme oku camgöbeği parçacıkla akar — yön görünür olsun diye
   ============================================================ */
(function (g) {
  'use strict';

  var AZ_HAREKET = false;
  try {
    AZ_HAREKET = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) { }

  var UCGEN  = [3, 6, 9];
  var HEKSAD = [1, 4, 2, 8, 5, 7];

  function hazirla(cv) {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = cv.clientWidth || 320, h = cv.clientHeight || 320;
    if (cv.width !== Math.round(w * dpr) || cv.height !== Math.round(h * dpr)) {
      cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr);
    }
    var ctx = cv.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    return { ctx: ctx, w: w, h: h };
  }
  function gorunurlukBagla(cv, durum) {
    if (!window.IntersectionObserver) { durum.gorunur = true; return; }
    var io = new IntersectionObserver(function (e) { durum.gorunur = e[0].isIntersecting; }, { threshold: 0.01 });
    io.observe(cv); durum.gorunur = true; return io;
  }

  /** Tipin çember üzerindeki açısı (radyan). 9 tepede. */
  function aci(tip) { return (-90 + (tip % 9) * 40) * Math.PI / 180; }

  function dondurY(p, a) {
    var c = Math.cos(a), s = Math.sin(a);
    return { x: p.x * c + p.z * s, y: p.y, z: -p.x * s + p.z * c };
  }
  function dondurX(p, a) {
    var c = Math.cos(a), s = Math.sin(a);
    return { x: p.x, y: p.y * c - p.z * s, z: p.y * s + p.z * c };
  }
  function yansit(p, cx, cy, d) {
    var f = d / (d + p.z);
    return { x: cx + p.x * f, y: cy + p.y * f, f: f, z: p.z };
  }

  /**
   * cv    : canvas
   * veri  : { anaTip, kanat, stresOk, buyumeOk, renkler:{1..9}, vurgu, sadeMi }
   */
  function enneagram(cv, veri) {
    var durum = { calisiyor: true, gorunur: true, don: 0, egim: 0.30, surukle: null };
    gorunurlukBagla(cv, durum);

    var VURGU  = veri.vurgu  || '#3ddad7';   /* büyüme / camgöbeği */
    var STRESR = veri.stresRenk || '#e05555';
    var renkler = veri.renkler || {};

    /* akan parçacıklar: her ok için birkaç nokta, 0..1 arası ilerler */
    var akis = [];
    if (veri.stresOk)  for (var i = 0; i < 4; i++) akis.push({ tur: 'stres',  t: i / 4 });
    if (veri.buyumeOk) for (var j = 0; j < 4; j++) akis.push({ tur: 'buyume', t: j / 4 });

    function bas(e) { durum.surukle = { x: (e.touches ? e.touches[0] : e).clientX, don: durum.don }; }
    function hareket(e) {
      if (!durum.surukle) return;
      var x = (e.touches ? e.touches[0] : e).clientX;
      durum.don = durum.surukle.don + (x - durum.surukle.x) * 0.007;
      if (e.cancelable && e.touches) e.preventDefault();
    }
    function birak() { durum.surukle = null; }
    cv.addEventListener('mousedown', bas);
    cv.addEventListener('touchstart', bas, { passive: true });
    window.addEventListener('mousemove', hareket);
    cv.addEventListener('touchmove', hareket, { passive: false });
    window.addEventListener('mouseup', birak);
    window.addEventListener('touchend', birak);

    var t = 0;
    function cerceve() {
      if (!durum.calisiyor) return;
      requestAnimationFrame(cerceve);
      if (!durum.gorunur) return;

      var h = hazirla(cv), ctx = h.ctx, w = h.w, hh = h.h;
      var cx = w / 2, cy = hh / 2, d = 900;
      var R = Math.min(w, hh) * 0.36;
      var nokR = Math.max(9, R * 0.10);

      ctx.clearRect(0, 0, w, hh);
      t += 1;
      if (!durum.surukle && !AZ_HAREKET) durum.don += 0.0022;

      /* 3B konum: sembol XY düzleminde, hafif eğik ve Y ekseninde dönüyor */
      function konum(tip, olcek) {
        var a = aci(tip), r = R * (olcek || 1);
        var p = { x: Math.cos(a) * r, y: Math.sin(a) * r, z: 0 };
        return yansit(dondurX(dondurY(p, durum.don), durum.egim), cx, cy, d);
      }
      /* iki tip arasında oranla ara nokta (akan parçacık için) */
      function arada(a1, a2, k) {
        var p1 = konum(a1), p2 = konum(a2);
        return { x: p1.x + (p2.x - p1.x) * k, y: p1.y + (p2.y - p1.y) * k,
                 f: p1.f + (p2.f - p1.f) * k };
      }

      /* ---- dış çember ---- */
      ctx.beginPath();
      for (var s = 0; s <= 96; s++) {
        var aa = (s / 96) * Math.PI * 2;
        var pp = yansit(dondurX(dondurY({ x: Math.cos(aa) * R, y: Math.sin(aa) * R, z: 0 }, durum.don), durum.egim), cx, cy, d);
        if (s === 0) ctx.moveTo(pp.x, pp.y); else ctx.lineTo(pp.x, pp.y);
      }
      ctx.closePath();
      ctx.strokeStyle = 'rgba(120,170,200,0.26)';
      ctx.lineWidth = 1.2; ctx.stroke();

      /* ---- üçgen 3-6-9 ---- */
      ctx.beginPath();
      UCGEN.forEach(function (n, k) {
        var p = konum(n);
        if (k === 0) ctx.moveTo(p.x, p.y); else ctx.lineTo(p.x, p.y);
      });
      ctx.closePath();
      ctx.strokeStyle = 'rgba(201,139,94,0.34)';   /* bakır */
      ctx.lineWidth = 1.3; ctx.stroke();

      /* ---- heksad 1-4-2-8-5-7 ---- */
      ctx.beginPath();
      HEKSAD.forEach(function (n, k) {
        var p = konum(n);
        if (k === 0) ctx.moveTo(p.x, p.y); else ctx.lineTo(p.x, p.y);
      });
      ctx.closePath();
      ctx.strokeStyle = 'rgba(120,170,200,0.30)';
      ctx.lineWidth = 1.1; ctx.stroke();

      /* ---- kullanıcının okları: kalın hat + akan parçacık ---- */
      function okCiz(hedef, renk) {
        if (!veri.anaTip || !hedef) return;
        var p1 = konum(veri.anaTip), p2 = konum(hedef);
        ctx.beginPath(); ctx.moveTo(p1.x, p1.y); ctx.lineTo(p2.x, p2.y);
        ctx.strokeStyle = renk + '66';
        ctx.lineWidth = 2.4; ctx.lineCap = 'round'; ctx.stroke();
      }
      okCiz(veri.stresOk, STRESR);
      okCiz(veri.buyumeOk, VURGU);

      if (!AZ_HAREKET) {
        akis.forEach(function (a) {
          a.t += 0.0055;
          if (a.t > 1) a.t -= 1;
          var hedef = a.tur === 'stres' ? veri.stresOk : veri.buyumeOk;
          if (!hedef || !veri.anaTip) return;
          var p = arada(veri.anaTip, hedef, a.t);
          var renk = a.tur === 'stres' ? STRESR : VURGU;
          var sol = Math.sin(a.t * Math.PI);        /* uçlarda sönük, ortada parlak */
          ctx.fillStyle = renk + Math.round(sol * 220).toString(16).padStart(2, '0');
          ctx.beginPath(); ctx.arc(p.x, p.y, 3.1 * p.f, 0, 6.2832); ctx.fill();
        });
      }

      /* ---- düğümler: arkadan öne ---- */
      var dugumler = [];
      for (var n = 1; n <= 9; n++) dugumler.push({ n: n, p: konum(n) });
      dugumler.sort(function (a, b) { return b.p.z - a.p.z; });

      dugumler.forEach(function (o) {
        var n = o.n, p = o.p;
        var ana = n === veri.anaTip;
        var kanat = n === veri.kanat;
        var okucu = n === veri.stresOk || n === veri.buyumeOk;
        var renk = renkler[n] || '#8fb4c8';
        var rr = nokR * (ana ? 1.55 : (kanat ? 1.16 : 1)) * p.f;
        var op = ana ? 1 : (kanat || okucu ? 0.85 : 0.42);

        if (ana) {
          var hale = ctx.createRadialGradient(p.x, p.y, rr * 0.3, p.x, p.y, rr * 3.4);
          hale.addColorStop(0, renk + 'aa');
          hale.addColorStop(0.4, renk + '33');
          hale.addColorStop(1, 'rgba(0,0,0,0)');
          ctx.fillStyle = hale;
          ctx.beginPath(); ctx.arc(p.x, p.y, rr * 3.4, 0, 6.2832); ctx.fill();
        }

        ctx.globalAlpha = op;
        var kg = ctx.createRadialGradient(p.x - rr * 0.3, p.y - rr * 0.34, rr * 0.1, p.x, p.y, rr);
        kg.addColorStop(0, '#ffffff');
        kg.addColorStop(0.55, renk);
        kg.addColorStop(1, 'rgba(8,17,28,0.92)');
        ctx.fillStyle = kg;
        ctx.beginPath(); ctx.arc(p.x, p.y, rr, 0, 6.2832); ctx.fill();

        if (ana || kanat) {
          ctx.strokeStyle = 'rgba(255,255,255,0.55)';
          ctx.lineWidth = 1.1;
          ctx.beginPath(); ctx.arc(p.x, p.y, rr, 0, 6.2832); ctx.stroke();
        }

        ctx.fillStyle = ana || kanat ? '#0a1420' : 'rgba(10,20,32,0.85)';
        ctx.font = '700 ' + Math.round(rr * (ana ? 1.05 : 0.95)) + 'px ui-sans-serif, system-ui, sans-serif';
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.fillText(String(n), p.x, p.y + rr * 0.04);
        ctx.globalAlpha = 1;
      });

      ctx.textAlign = 'start'; ctx.textBaseline = 'alphabetic';
    }
    requestAnimationFrame(cerceve);

    return {
      durdur: function () {
        durum.calisiyor = false;
        window.removeEventListener('mousemove', hareket);
        window.removeEventListener('mouseup', birak);
        window.removeEventListener('touchend', birak);
      },
      guncelle: function (yeni) { for (var k in yeni) veri[k] = yeni[k]; }
    };
  }

  /* ---------------------------------------------------------- üç merkez

     TASARIM NOTU: İlk sürüm üç merkezi YAN YANA küreler + yörünge elipsi olarak
     çiziyordu; bu bir atom/molekül diyagramı gibi okunuyordu. Enneagram'da üç
     merkez bedende DİKEY sıralanır (baş · kalp · karın), o yüzden şimdi:
       · dikey eksende üç ışık düğümü, aralarında akan enerji kanalı
       · küre yerine hale + kadim glif
       · baskın merkez daha büyük ve parlak, halkası döner
     ============================================================ */
  var MERKEZ_GLIF = { zihin: '◈', kalp: '✧', beden: '▲' };

  function merkezler(cv, veri) {
    var durum = { calisiyor: true, gorunur: true };
    gorunurlukBagla(cv, durum);
    var K = veri.kume || [
      { k: 'zihin', ad: 'Zihin', deger: 0.33, renk: '#5f86e0' },
      { k: 'kalp',  ad: 'Kalp',  deger: 0.33, renk: '#f0919b' },
      { k: 'beden', ad: 'Beden', deger: 0.33, renk: '#63b487' }
    ];
    var enBuyuk = Math.max.apply(null, K.map(function (m) { return m.deger; }));

    var t = 0;
    function cerceve() {
      if (!durum.calisiyor) return;
      requestAnimationFrame(cerceve);
      if (!durum.gorunur) return;

      var h = hazirla(cv), ctx = h.ctx, w = h.w, hh = h.h;
      ctx.clearRect(0, 0, w, hh);
      t += 1;

      var cx = w * 0.38;                       /* eksen biraz solda; sağ taraf etiketlere */
      var ust = hh * 0.16, alt = hh * 0.84;
      var adim = (alt - ust) / (K.length - 1);
      var taban = Math.min(hh * 0.15, w * 0.10);

      /* --- dikey enerji kanalı (omurga) --- */
      var kg = ctx.createLinearGradient(cx, ust, cx, alt);
      kg.addColorStop(0, K[0].renk + '55');
      kg.addColorStop(0.5, K[1].renk + '55');
      kg.addColorStop(1, K[2].renk + '55');
      ctx.beginPath();
      ctx.moveTo(cx, ust); ctx.lineTo(cx, alt);
      ctx.strokeStyle = kg; ctx.lineWidth = 2; ctx.lineCap = 'round'; ctx.stroke();

      /* kanalda yukarı süzülen ışık zerreleri */
      if (!AZ_HAREKET) {
        for (var z = 0; z < 5; z++) {
          var ilerle = ((t * 0.004) + z * 0.2) % 1;
          var py = alt - (alt - ust) * ilerle;
          var op = Math.sin(ilerle * Math.PI) * 0.7;
          ctx.fillStyle = 'rgba(201,232,244,' + op.toFixed(3) + ')';
          ctx.beginPath(); ctx.arc(cx, py, 1.9, 0, 6.2832); ctx.fill();
        }
      }

      K.forEach(function (m, i) {
        var cy = ust + adim * i;
        var oran = enBuyuk > 0 ? m.deger / enBuyuk : 1;
        var baskin = Math.abs(m.deger - enBuyuk) < 0.0001;
        var r = taban * (0.5 + oran * 0.62);
        var nabiz = AZ_HAREKET ? 1 : 1 + (baskin ? 0.045 : 0.02) * Math.sin(t * 0.028 + i * 2);
        r *= nabiz;

        /* hale */
        var hg = ctx.createRadialGradient(cx, cy, r * 0.2, cx, cy, r * 2.9);
        hg.addColorStop(0, m.renk + (baskin ? 'bb' : '77'));
        hg.addColorStop(0.42, m.renk + '2a');
        hg.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = hg;
        ctx.beginPath(); ctx.arc(cx, cy, r * 2.9, 0, 6.2832); ctx.fill();

        /* dönen tılsım halkası — yalnız baskın merkezde */
        if (baskin) {
          var don = t * (AZ_HAREKET ? 0 : 0.006);
          ctx.beginPath(); ctx.arc(cx, cy, r * 1.75, 0, 6.2832);
          ctx.strokeStyle = m.renk + '4d'; ctx.lineWidth = 1; ctx.stroke();
          for (var s = 0; s < 8; s++) {
            var a = (s / 8) * 6.2832 + don;
            var sx = cx + Math.cos(a) * r * 1.75, sy = cy + Math.sin(a) * r * 1.75;
            ctx.fillStyle = m.renk + 'aa';
            ctx.beginPath(); ctx.arc(sx, sy, 1.6, 0, 6.2832); ctx.fill();
          }
        }

        /* çekirdek: ince çemberli ışık, içinde glif */
        ctx.beginPath(); ctx.arc(cx, cy, r, 0, 6.2832);
        ctx.fillStyle = 'rgba(7,15,25,0.72)'; ctx.fill();
        ctx.strokeStyle = m.renk + (baskin ? 'ee' : '88');
        ctx.lineWidth = baskin ? 1.8 : 1.1; ctx.stroke();

        ctx.save();
        ctx.shadowColor = m.renk; ctx.shadowBlur = baskin ? r * 0.9 : r * 0.4;
        ctx.fillStyle = baskin ? '#ffffff' : m.renk;
        ctx.font = Math.round(r * 0.95) + 'px ui-sans-serif, system-ui, sans-serif';
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.fillText(MERKEZ_GLIF[m.k] || '◇', cx, cy + r * 0.04);
        ctx.restore();

        /* etiket: eksenin sağında, dikey hizada */
        var ex = cx + taban * 1.9;
        ctx.textAlign = 'left'; ctx.textBaseline = 'middle';
        ctx.fillStyle = baskin ? 'rgba(232,242,248,0.96)' : 'rgba(160,184,202,0.8)';
        ctx.font = (baskin ? '600 ' : '400 ') + Math.round(Math.min(14, w / 26)) + 'px ui-sans-serif, system-ui, sans-serif';
        ctx.fillText(m.ad, ex, cy - 8);
        ctx.fillStyle = m.renk;
        ctx.font = '300 ' + Math.round(Math.min(17, w / 22)) + 'px ui-sans-serif, system-ui, sans-serif';
        ctx.fillText('%' + Math.round(m.deger * 100), ex, cy + 11);
      });

      ctx.textAlign = 'start'; ctx.textBaseline = 'alphabetic';
    }
    requestAnimationFrame(cerceve);
    return { durdur: function () { durum.calisiyor = false; } };
  }

  /* ---------------------------------------------------------- arka plan alanı */
  /** Soru ekranı arka planı: derinlikte süzülen sembol hatları. */
  function alan(cv, renk) {
    var durum = { calisiyor: true, gorunur: true };
    gorunurlukBagla(cv, durum);
    var par = [];
    for (var i = 0; i < 44; i++) {
      par.push({ x: (Math.random() - 0.5) * 1100, y: (Math.random() - 0.5) * 800,
                 z: Math.random() * 1000, r: 6 + Math.random() * 22, s: 0.3 + Math.random() * 0.8 });
    }
    var t = 0;
    function cerceve() {
      if (!durum.calisiyor) return;
      requestAnimationFrame(cerceve);
      if (!durum.gorunur) return;
      var h = hazirla(cv), ctx = h.ctx, w = h.w, hh = h.h;
      var cx = w / 2, cy = hh / 2;
      ctx.clearRect(0, 0, w, hh);
      t += 1;
      par.sort(function (a, b) { return b.z - a.z; });
      par.forEach(function (p) {
        if (!AZ_HAREKET) {
          p.z -= p.s * 1.3;
          if (p.z < 20) { p.z = 1000; p.x = (Math.random() - 0.5) * 1100; p.y = (Math.random() - 0.5) * 800; }
        }
        var f = 430 / (430 + p.z);
        var x = cx + p.x * f, y = cy + p.y * f;
        if (x < -60 || x > w + 60 || y < -60 || y > hh + 60) return;
        var op = Math.min(0.26, f * 0.4) * (0.55 + 0.45 * Math.sin(t * 0.01 + p.r));
        ctx.strokeStyle = (renk || '#3ddad7') + Math.round(op * 255).toString(16).padStart(2, '0');
        ctx.lineWidth = 1;
        /* küçük dokuz-köşeli hat */
        ctx.beginPath();
        for (var k = 0; k <= 9; k++) {
          var a = (-90 + k * 40) * Math.PI / 180;
          var px = x + Math.cos(a) * p.r * f * 2.4, py = y + Math.sin(a) * p.r * f * 2.4;
          if (k === 0) ctx.moveTo(px, py); else ctx.lineTo(px, py);
        }
        ctx.stroke();
      });
    }
    requestAnimationFrame(cerceve);
    return { durdur: function () { durum.calisiyor = false; } };
  }

  g.ODTSembol = { enneagram: enneagram, merkezler: merkezler, alan: alan, aci: aci, AZ_HAREKET: AZ_HAREKET };
})(typeof window !== 'undefined' ? window : globalThis);
